import React from 'react';
import { Link } from 'react-router-dom';
import { MatchResult } from '../../services/matchingService';
interface MatchCardProps {
  match: MatchResult;
  name: string;
  description: string;
  location?: string;
  imageUrl?: string;
  type: 'brand' | 'organizer';
}
export function MatchCard({
  match,
  name,
  description,
  location,
  imageUrl,
  type
}: MatchCardProps) {
  // Determine color based on match score
  const scoreColor = match.score >= 80 ? 'bg-green-100 text-green-800' : match.score >= 60 ? 'bg-indigo-100 text-indigo-800' : 'bg-gray-100 text-gray-800';
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200" data-id="element-582">
      <div className="flex items-start justify-between mb-4" data-id="element-583">
        <div className="flex items-center gap-4" data-id="element-584">
          <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center overflow-hidden" data-id="element-585">
            {imageUrl ? <img src={imageUrl} alt={name} className="w-full h-full object-cover" data-id="element-586" /> : <span className="text-xl font-bold text-gray-400" data-id="element-587">
                {name.charAt(0)}
              </span>}
          </div>
          <div data-id="element-588">
            <h3 className="font-bold text-lg text-gray-900" data-id="element-589">{name}</h3>
            {location && <p className="text-sm text-gray-500" data-id="element-590">{location}</p>}
          </div>
        </div>
        <div className={`px-3 py-1 rounded-full text-sm font-bold ${scoreColor}`} data-id="element-591">
          {match.score}% Match
        </div>
      </div>

      <p className="text-gray-600 text-sm mb-4 line-clamp-2" data-id="element-592">{description}</p>

      <div className="bg-gray-50 rounded-lg p-4 mb-4" data-id="element-593">
        <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-594">
          Why this works
        </h4>
        <ul className="space-y-2" data-id="element-595">
          {match.matchReasons.slice(0, 3).map((reason, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-596">
              <span className="text-green-500 mt-0.5" data-id="element-597">✓</span>
              {reason}
            </li>)}
        </ul>
      </div>

      <Link to={`/dashboard/${type === 'brand' ? 'brand' : 'organizer'}/matches/${match.id}`} className="block w-full text-center bg-white border border-indigo-600 text-indigo-600 font-medium py-2 rounded-lg hover:bg-indigo-50 transition-colors" data-id="element-598">
        View Details
      </Link>
    </div>;
}